import { useLocale } from '../hooks/useLocale.jsx';

// "내 페이지" 머리. 예전엔 디자인 / 컬렉션 하위 탭이었는데 컬렉션은 거의 안 쓰여
// (2026-10 기준 11개) 진입점을 뗐다 — 탭이 하나뿐이면 탭이 아니라 제목이다.
// /bookmarks·/c/:id 라우트는 남아 있어 기존 링크는 열린다.
// 모바일은 탭 root 라 제목 없이 (CSS 로 숨김), 데스크톱만 제목을 단다.
// `user` 는 안 쓰지만 호출부 시그니처를 유지한다.
export function MyTabs({ user, current }) { // eslint-disable-line no-unused-vars
  const { t } = useLocale();
  return (
    <h1 className="my-page-title">{current === 'collections' ? t('tabCollections') : t('myDesigns')}</h1>
  );
}
